import React from 'react'
import { connect } from 'react-redux'
import { Button, Div, H3, P } from '@driftt/tide-core'
import * as Sentry from '@sentry/browser'
import DizzyRobot from 'images/dizzy-robot.svg'

const mapStateToProps = state => ({
  userEmail: state.user.email,
  userName: state.user.name 
})

const ErrorFallback = ({ userEmail, userName }) => (
  <Div className="error-empty-state--wrapper">
    <img src={DizzyRobot} alt="dizzy robot error illustration" />
    <H3>Sorry, something went wrong.</H3>
    <P>You can help improve Drift by providing more information about what happened!</P>
    <Button 
      onClick={() => Sentry.showReportDialog({
        user: {
          email: userEmail,
          name: userName
        }
      })} 
      type="primary">Submit your feedback</Button>
  </Div>
)

export default connect(mapStateToProps)(ErrorFallback)
